import { render, staticRenderFns } from "./DatosResponsables.vue?vue&type=template&id=3b6914d6"
import script from "./DatosResponsables.vue?vue&type=script&lang=js"
export * from "./DatosResponsables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports